import React from "react";
//Material imports
import Grid from "@mui/material/Grid";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { useExpertDashboard, useExpertRatingContext } from "@limitless/expert";
import { formatRating } from "@limitless/common/utils";
import DashboardChart from "./DashboardChart";
import DashboardGraphHeader from "./DashboardGraphHeader";
import { commonStyle } from "./DashboardRewards";
import * as ReactDOMServer from "react-dom/server";
import DashboardCommonTooltip from "./DashboardCommonTooltip";
import { useTheme } from "@mui/material/styles";

const DashboardRatings = () => {
    const classes = commonStyle();
    const { t } = useTranslation();
    const theme = useTheme();
    const {
        fetchMontlyRatingData,
        currentMonthPloting,
        month,
        group,
        ratingStatus,
        ratingRate,
        categories,
        ratingMonths,
        rating
    } = useExpertDashboard();
    const { groupSuggestions } = useExpertRatingContext();

    const series = React.useMemo(() => {
        return [
            {
                name: t("this month"),
                data: currentMonthPloting
            }
        ];
    }, [currentMonthPloting]);

    React.useEffect(() => {
        if (Object.keys(ratingMonths).length !== 0) {
            fetchMontlyRatingData(month, group);
        }
    }, [ratingMonths]);

    const options = {
        tooltip: {
            custom: ({ seriesIndex, dataPointIndex, w }) => {
                const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

                return data.date
                    ? ReactDOMServer.renderToStaticMarkup(
                          <DashboardCommonTooltip
                              className="arrow_box"
                              date={data.date}
                              value={data.value}
                              theme={theme}
                              valueText={t("rating score")}
                          />
                      )
                    : "";
            },
            theme: true
        },
        colors: ["#388E3C"],
        yaxis: {
            min: 0,
            max: 100,
            tickAmount: 4,
            opposite: true,
            labels: {
                formatter(val) {
                    return `${val}%`;
                },
                style: {
                    colors: theme.palette.text.secondary
                }
            }
        },
        markers: {
            size: 5,
            strokeColor: "transparent",
            hover: {
                size: 10,
                strokeWidth: 2,
                sizeOffset: 3
            }
        },
        stroke: {
            curve: "straight"
        }
    };

    return (
        <Grid container className={classes.container}>
            <DashboardGraphHeader
                title="Expert rating"
                fetchMontlyData={fetchMontlyRatingData}
                leftTitle={formatRating(Math.round(rating))}
                status={ratingStatus}
                monthSuggestionForRating={ratingMonths}
                groupSuggestionForRating={groupSuggestions}
                rate={Math.abs(ratingRate).toFixed(2)}
            />

            <Grid className="chart">
                <DashboardChart series={series} categories={categories} chartType="area" tickAmount options={options} />
            </Grid>
        </Grid>
    );
};

export default DashboardRatings;
